import { render, staticRenderFns } from "./Aboutus.vue?vue&type=template&id=24ea978e&scoped=true"
import script from "./Aboutus.vue?vue&type=script&lang=js"
export * from "./Aboutus.vue?vue&type=script&lang=js"
import style0 from "./Aboutus.vue?vue&type=style&index=0&id=24ea978e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ea978e",
  null
  
)

export default component.exports